const PASSWORD_RESET_LINK_LIFETIME_HOURS = 1
export const PASSWORD_RESET_LINK_LIFETIME_MS = PASSWORD_RESET_LINK_LIFETIME_HOURS * 60 * 60 * 1000
export const PASSWORD_RESET_LINK_LIFETIME_LABEL = `${PASSWORD_RESET_LINK_LIFETIME_HOURS} hour${PASSWORD_RESET_LINK_LIFETIME_HOURS === 1 ? "" : "s"}`

// Clerk refuses a password that an Admin marked compromised or that appears in
// a known breach. The account then signs in only through a reset by email code.
const RESET_REQUIRED_CODES = new Set(["form_password_compromised", "form_password_pwned"])

export function passwordResetRequired(error: unknown): boolean {
  if (!error || typeof error !== "object" || !("errors" in error)) return false
  const errors = (error as { errors?: unknown }).errors
  return Array.isArray(errors) && errors.some((entry) => (
    Boolean(entry) && typeof entry === "object" && RESET_REQUIRED_CODES.has(String((entry as { code?: unknown }).code))
  ))
}
